<div class="task agenda-detailed-task" [ngStyle]="viewTask().style"
     (click)="onTaskClick($event, viewTask().task)"
     (mouseenter)="taskHover.emit(viewTask().task)"
     (mouseleave)="taskHover.emit(null)">
  @if (options().canResize && viewTask().task.enable) {
    <div class="task-resize-box" (mousedown)="startResizeTask(viewTask(), $event, 'top')"></div>
  }
  <div class="task-background"
       [style.background-color]="viewTask().task.backgroundColor.length === 9 ? viewTask().task.backgroundColor : viewTask().task.backgroundColor + 'BF'">
    <div class="task-content" [innerHTML]="viewTask().task.label"></div>
  </div>
  @if (options().canResize && viewTask().task.enable) {
    <div class="task-resize-box bottom" (mousedown)="startResizeTask(viewTask(), $event, 'bottom')"></div>
  }
</div>
